import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { experiences } from '../mock';
import useReveal from '../hooks/useReveal';

function ExpCard({ exp, index }) {
  const { lang } = useLang();
  const [ref, visible] = useReveal();
  return (
    <article
      ref={ref}
      style={{ transitionDelay: `${(index % 3) * 0.12}s` }}
      className={`reveal ${visible ? 'is-visible' : ''} group relative overflow-hidden rounded-[2px] cursor-pointer shadow-[0_18px_40px_-24px_rgba(42,36,32,0.55)]`}
    >
      <div className="h-80 overflow-hidden">
        <img
          src={exp.image}
          alt={exp.title[lang]}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1.2s] ease-out"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-[#2A2420]/90 via-[#2A2420]/25 to-transparent" />

      <span className="absolute top-4 left-4 font-body text-[11px] tracking-[0.2em] uppercase text-[#2A2420] bg-[#E7DAC4]/95 px-3 py-1 rounded-full">
        {exp.tag[lang]}
      </span>

      <div className="absolute bottom-0 left-0 right-0 p-6">
        <h3 className="font-display text-2xl md:text-[1.7rem] text-white mb-2 flex items-center gap-2">
          {exp.title[lang]}
          <ArrowUpRight className="w-5 h-5 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-400 text-[#D69A4C]" />
        </h3>
        <p className="font-body text-white/0 group-hover:text-white/85 text-sm leading-relaxed max-h-0 group-hover:max-h-40 overflow-hidden transition-all duration-500">
          {exp.desc[lang]}
        </p>
      </div>
    </article>
  );
}

export default function Experiences() {
  const { t } = useLang();
  return (
    <section id="cosa-fare" className="py-24 md:py-36 bg-[#F6EFE3]">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="font-body text-[#B5603A] tracking-[0.35em] uppercase text-xs mb-5">{t('experiences.kicker')}</p>
          <h2 className="font-display text-4xl md:text-6xl text-[#2A2420] mb-5">{t('experiences.title')}</h2>
          <p className="font-body text-[#6E655B] text-lg leading-relaxed">{t('experiences.subtitle')}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {experiences.map((exp, i) => (
            <ExpCard key={exp.id} exp={exp} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
